import React from "react";
import { NumberField } from "@heroui/react";

export interface RangeFilterGroupProps {
  label: string;
  fromValue?: number;
  toValue?: number;
  onFromChange: (value: number) => void;
  onToChange: (value: number) => void;
  minValue?: number;
  maxValue?: number;
  step?: number;
  formatOptions?: Intl.NumberFormatOptions;
  fromPlaceholder?: string;
  toPlaceholder?: string;
}

const RangeFilterGroup: React.FC<RangeFilterGroupProps> = ({
  label,
  fromValue,
  toValue,
  onFromChange,
  onToChange,
  minValue,
  maxValue,
  step,
  formatOptions,
  fromPlaceholder = "От",
  toPlaceholder = "До",
}) => {
  return (
    <div className="sc-filter-panel__group">
      <span className="sc-filter-panel__label">{label}</span>
      <div className="sc-filter-panel__range">
        <NumberField
          value={fromValue}
          onChange={onFromChange}
          minValue={minValue}
          maxValue={maxValue}
          step={step}
          formatOptions={formatOptions}
          className="sc-filter-panel__number-field"
        >
          <NumberField.Group className="w-full">
            <NumberField.Input
              placeholder={fromPlaceholder}
              className="w-full"
            />
          </NumberField.Group>
        </NumberField>
        <span className="sc-filter-panel__separator">—</span>
        <NumberField
          value={toValue}
          onChange={onToChange}
          minValue={minValue}
          maxValue={maxValue}
          step={step}
          formatOptions={formatOptions}
          className="sc-filter-panel__number-field"
        >
          <NumberField.Group className="w-full">
            <NumberField.Input placeholder={toPlaceholder} className="w-full" />
          </NumberField.Group>
        </NumberField>
      </div>
    </div>
  );
};

RangeFilterGroup.displayName = "RangeFilterGroup";
export default RangeFilterGroup;
